import {isDate, isObject, isString} from 'lodash';
import Moment from 'moment';
import 'moment/locale/fr';
import Pace from 'pace-progress';
import {toast} from "react-toastify";
import updateToast from "./updateToast";

Pace.options.ajax.ignoreURLs.push('/v1/files/printDocument');
Pace.options.eventLag = false;

export function convertDateToRemoveTimeZone(_date) {
    const minutesToAddForTimeZone = _date.getTimezoneOffset();

    if (minutesToAddForTimeZone !== 0) {
        const date = Moment(_date);

        if (minutesToAddForTimeZone > 0) {
            return date.add(minutesToAddForTimeZone, 'm').toDate();
        } else {
            return date.subtract(minutesToAddForTimeZone, 'm').toDate();
        }
    } else {
        return _date;
    }
}

function serialize(obj, isJson = false) {
    if (!(obj === Object(obj))) {
        console.log('Non-Object rejected for serialize', obj);
        return obj;
    }

    if (isJson === true) {
        Object.keys(obj).forEach((k) => {
            if (isDate(obj[k])) {
                obj[k] = convertDateToRemoveTimeZone(obj[k]);
            }
        });

        return JSON.stringify(obj);
    }

    const pairs = [];
    Object.keys(obj).forEach((k) => {
        if (obj[k] === undefined || obj[k] === null) {
            console.log('Property rejected for serialize', k, obj[k]);
            return;
        }

        if (isObject(obj[k])) {
            if (isDate(obj[k])) {
                obj[k] = convertDateToRemoveTimeZone(obj[k]);
                pairs.push(
                    encodeURIComponent(k) + '=' + encodeURIComponent(Moment(obj[k]).format('YYYY-MM-DDTHH:mm:ss'))
                );
                return;
            } else {
                console.log('Property rejected for serialize', k, obj[k]);
                return;
            }
        } else if (isString(obj[k])) {
            pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k].trim()));
            return;
        }

        pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
    });
    return pairs.join('&');
}

function generateXHR(resolve, reject) {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
            // No body status code
            if (xhr.status === 204) {
                return resolve({body: null, status: xhr.status, xhr});
            }

            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    const response = JSON.parse(xhr.responseText);

                    resolve({
                        body: response,
                        status: xhr.status,
                        xhr
                    });
                } catch (e) {
                    reject(e);
                }
            } else {
                if (xhr.status === 403) {

                    console.log("FORBIDDEN");

                    //Toaster.addDangerMessage("Forbidden");
                }

                reject(xhr);
            }
        }
    };

    return xhr;
}

function generatePromise(verb = "GET", url = "/", params = null, body = null) {
    return new Promise((resolve, reject) => {
        Pace.start();
        const xhr = generateXHR(resolve, reject);
        let URL = process.env.APP_API_ENDPOINT + url;
        const sendJSON = ['POST', 'PUT'].indexOf(verb) >= 0;

        if (params) {
            URL += `?${serialize(params, false)}`;
        }

        xhr.open(verb, URL, true);
        xhr.withCredentials = true;

        if (sendJSON === true) {
            xhr.setRequestHeader("Content-type", "application/json");
        }

        if (body !== null) {
            body = serialize(body, sendJSON);
        }

        xhr.send(body);
    });
}

export function Get(url, params, body) {
    return generatePromise('GET', url, params, body);
}

export function Delete(url) {
    return generatePromise('DELETE', url);
}

/**
 * @return {boolean}
 */
export async function Post(url, body, infoMessage = null, successOptions = null, errorOptions = null, preconditionOptions = null) {
    let toastID = null;

    try {

        if (infoMessage !== null) {
            toastID = isObject(infoMessage) ? infoMessage.toastID : toast.info(infoMessage, {autoClose: successOptions === null ? 5000 : false});
        }

        await generatePromise('POST', url, null, body);

        if (successOptions !== null && toastID !== null) {
            updateToast({
                type: toast.TYPE.SUCCESS,
                toastID: toastID,
                ...successOptions
            });
        }

    } catch (xhr) {

        if (xhr.status === 412) {

            if (preconditionOptions !== null && toastID !== null) {
                updateToast({
                    type: toast.TYPE.WARNING,
                    toastID: toastID,
                    ...preconditionOptions
                });
            }

            return false;
        }

        console.log(xhr);

        if (errorOptions !== null && toastID !== null) {
            updateToast({
                type: toast.TYPE.ERROR,
                toastID: toastID,
                ...errorOptions
            });
        }

        return false;
    }

    return true;
}

export async function OpenFile(url) {
    return await GetPromiseFile(url, {}, true);
}

/**
 * @return {boolean}
 */
export async function GetFile(url, body, infoMessage = "En cours..", successOptions = null, errorOptions = null, withPrecondition = true) {
    let toastID;
    try {
        toastID = toast.info(infoMessage, {autoClose: false});

        if (withPrecondition) await Get(url + "?CheckPrecondition=true");
        await GetPromiseFile(url, body);

        if (successOptions !== null) {
            updateToast({
                type: toast.TYPE.SUCCESS,
                toastID: toastID,
                ...successOptions
            });
        }

    } catch (xhr) {

        console.log(xhr);
        if (errorOptions !== null) {
            updateToast({
                type: toast.TYPE.ERROR,
                toastID: toastID,
                ...errorOptions
            });
        }

        return false;
    }

    return true;
}

function GetPromiseFile(url, body, open = false, verb = 'GET') {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.onload = () => {
            if (xhr.status === 200) {
                // Create a new Blob object using the
                //response data of the onload object
                const blob = xhr.response;
                var url = window.URL.createObjectURL(blob);

                if (open) {
                    var win = window.open(url);
                    win.document.write('<body style="border:0; padding:0; margin:0;"><iframe src="' + url + '" frameborder="0" style="border:0; padding:0; margin:0; top:0; left:0; bottom:0; right:0; width:100%; height:100%;" allowfullscreen></iframe></body>');
                    resolve(win);
                } else {
                    //Create a link element, hide it, direct
                    //it towards the blob, and then 'click' it programatically
                    const a = document.createElement("a");
                    a.style = "display: none";
                    document.body.appendChild(a);
                    //Create a DOMString representing the blob
                    //and point the link element towards it
                    a.href = url;
                    a.download = xhr.getResponseHeader('Content-Disposition').split('=')[1].replace(/&quot;|"/g, '');
                    //programatically click the link to trigger the download
                    a.click();
                    //release the reference to the file by revoking the Object URL
                    window.URL.revokeObjectURL(a.href);
                    a.parentNode.removeChild(a);
                    resolve(xhr);
                }
            } else {
                reject(xhr);
            }
        };

        let URL = process.env.APP_API_ENDPOINT + url;
        const sendJSON = ['POST', 'PUT'].indexOf(verb) >= 0;

        if (sendJSON === true) {
            body = serialize(body, sendJSON);
        } else {
            URL += `?${serialize(body, false)}`;
        }

        xhr.open(verb, URL, true);

        if (sendJSON === true) {
            xhr.setRequestHeader("Content-type", "application/json");
        }

        xhr.withCredentials = true;
        xhr.responseType = "blob";
        xhr.send(sendJSON === true ? body : null);
    });
}

export function PostFile(file) {
    return new Promise((resolve, reject) => {
        const form = new FormData();
        form.append('file', file);

        const xhr = generateXHR(resolve, reject);
        const URL = process.env.APP_API_ENDPOINT + '/v1/files';

        xhr.open('POST', URL, true);
        xhr.withCredentials = true;
        xhr.send(form);
    });
}